import { FieldDataType } from '../enums/FieldDataType';
import { FieldValidationType } from '../enums/FieldValidationType';
import { mapFieldDataType } from '../utils/clientFieldHelpers';
import { validateStringInput } from '../utils/formValidationHelpers';

export type ClientField = {
    fieldType: FieldDataType;
    validationType: FieldValidationType;
    fieldId: number;
    clientId: number;
    label: string;
    isPrimary: boolean;
    isReadOnly: boolean;
    isUnique: boolean;
    isFilterable: boolean;
    isVerifiable: boolean;
    isVerified: boolean;
};

export type CreateClientFieldRequest = {
    fieldType: FieldDataType;
    validationType: FieldValidationType;
    label: string;
    isPrimary: boolean;
    isUnique: boolean;
    isFilterable: boolean;
    isVerifiable: boolean;
    isVerified: boolean;
};

/**
 * buildCreateClientField
 *
 * @description
 * Builds an client field object which matches the object expected by the server
 * in a request to create a new client custom field.
 */
export function buildCreateClientField(args: {
    validationType: FieldValidationType;
    label: string;
    isUnique?: boolean;
    isFilterable?: boolean;
    isPrimary?: boolean;
    isVerifiable: boolean;
    isVerified: boolean;
}): CreateClientFieldRequest {
    return {
        fieldType: mapFieldDataType(args.validationType),
        validationType: args.validationType,
        label: validateStringInput('label', args.label),
        isUnique: args.isUnique || false,
        isFilterable: args.isFilterable || false,
        isPrimary: args.isPrimary || false,
        isVerifiable: args.isVerifiable || false,
        isVerified: args.isVerified || false,
    };
}

export type UpdateClientFieldRequest = {
    fieldType: FieldDataType;
    validationType: FieldValidationType;
    fieldId: number;
    label: string;
    isPrimary: boolean;
    isUnique: boolean;
    isFilterable: boolean;
    isVerifiable: boolean;
    isVerified: boolean;
};

/**
 * buildUpdateClientField
 *
 * @description
 * Builds an client field object which matches the object expected by the server
 * in a request to update and existing client custom field.
 */
export function buildUpdateClientField(field: ClientField): UpdateClientFieldRequest {
    return {
        fieldId: field.fieldId,
        fieldType: field.fieldType,
        validationType: field.validationType,
        label: validateStringInput('label', field.label),
        isPrimary: field.isPrimary,
        isUnique: field.isUnique,
        isFilterable: field.isFilterable,
        isVerifiable: field.isVerifiable,
        isVerified: field.isVerified,
    };
}

export type ClientFieldsGroupedByValidationType = {
    address: ClientField[];
    date: ClientField[];
    dollar: ClientField[];
    email: ClientField[];
    none: ClientField[];
    other: ClientField[];
    phone: ClientField[];
    year: ClientField[];
};
